import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import NewsItem from '../model/NewsItem';
import AbstractRestService from './abstract-rest-service.interface';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class NewsStore extends AbstractRestService<NewsItem> {
  constructor(http: HttpClient, env: EnvironmentService) {
    super(http, env.newsFetchUrl);
  }
}
